import { api } from '@/lib/api';

/** V4.9.24 — Admin ("API" page) management of the Sheets export API key. */
export interface ApiStatus {
  enabled: boolean;
  has_key: boolean;
  key_hint: string | null;
  key_generated_at: string | null;
  updated_by_name: string | null;
  env_fallback_present: boolean;
}

export interface GenerateKeyResult {
  api_key: string; // plaintext — returned ONCE
  key_hint: string;
}

export const apiAccessApi = {
  status: () => api.get<ApiStatus>('/sheets/config'),
  generateKey: () => api.post<GenerateKeyResult>('/sheets/config/key', {}),
  enable: () => api.post<{ success: true; enabled: boolean }>('/sheets/config/enable', {}),
  disable: () => api.post<{ success: true; enabled: boolean }>('/sheets/config/disable', {})
};
